// extracted by mini-css-extract-plugin
export var divider = "_z-0";
export var dividerText = "_z-1";